import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  AuthProvider,
  LoadingScreen,
  ImpersonationWrapper,
  APIProvider,
  MegaWrapper,
  MenuProvider,
  accessControl,
  FeatureProvider,
  NotificationProvider,
  AccessibilityProvider,
  ChatBotWrapper,
  MockProvider,
  DemoProvider,
} from '@monash/portal-frontend-common';
import homeLoading from './assets/lotties/home-loading.json';
import { Router } from '@monash/portal-react';
import SearchProvider from './components/providers/search-provider/SearchProvider';
import initMonitoring from './initMonitoring';
import { FEATURE_FLAGS } from './constants/features';
import { REAL_ENDPOINTS_LIST } from './constants/real-endpoints';

const env = import.meta.env.VITE_ENV;
if (env !== 'local') {
  initMonitoring(env);
}

const container = document.getElementById('root');
const root = createRoot(container);

const loadingScreen = <LoadingScreen animation={homeLoading} />;

const wrappers = [
  {
    comp: FeatureProvider,
    props: {
      defaultFeatureFlags: FEATURE_FLAGS,
    },
  },
  {
    comp: AuthProvider,
    props: {
      nolanding: true,
      loadingPage: loadingScreen,
      accessControl: (user, featureFlags) => {
        return (
          accessControl.isStudent(user) ||
          accessControl.isLinksUser(user) ||
          accessControl.isDemoUser(featureFlags?.DEMO_MODE)
        );
      },
      getPreferences: true,
    },
  },
  React.StrictMode,
  MockProvider,
  APIProvider,
  {
    comp: DemoProvider,
    props: {
      realApisList: REAL_ENDPOINTS_LIST,
    },
  },
  {
    comp: ImpersonationWrapper,
    props: {
      realApisList: REAL_ENDPOINTS_LIST,
    },
  },
  ChatBotWrapper,
  MenuProvider,
  AccessibilityProvider,
  Router,
  SearchProvider,
  NotificationProvider,
];

root.render(
  <MegaWrapper providers={wrappers}>
    <App />
  </MegaWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
